import { DracoCompression, KhronosTextureContainer2 } from '@babylonjs/core';

// TODO: embed latest from https://www.gstatic.com/draco/v1/decoders/*
import dracoFallback from './assets/draco/1.5.6/draco_decoder_gltf.js?url';
import dracoWasm from './assets/draco/1.5.6/draco_decoder_gltf.wasm?url';
import dracoWrapper from './assets/draco/1.5.6/draco_wasm_wrapper_gltf.js?url';
// TODO: embed latest from https://preview.babylonjs.com/*
import ktx2JsDecoder from './assets/ktx2Transcoder/babylon.ktx2Decoder.js?url';
import ktx2JsMSCTranscoder from './assets/ktx2Transcoder/msc_basis_transcoder.js?url';
import ktx2MSCTranscoder from './assets/ktx2Transcoder/msc_basis_transcoder.wasm?url';
import ktx2UASTCToASTC from './assets/ktx2Transcoder/uastc_astc.wasm?url';
import ktx2UASTCToBC7 from './assets/ktx2Transcoder/uastc_bc7.wasm?url';
import ktx2UASTCToR8_UNORM from './assets/ktx2Transcoder/uastc_r8_unorm.wasm?url';
import ktx2UASTCToBG8_UNORM from './assets/ktx2Transcoder/uastc_rg8_unorm.wasm?url';
import ktx2UASTCToRGBA_SRGB from './assets/ktx2Transcoder/uastc_rgba8_srgb_v2.wasm?url';
import ktx2UASTCToRGBA_UNORM from './assets/ktx2Transcoder/uastc_rgba8_unorm_v2.wasm?url';
import ktx2ZSTDDecoder from './assets/ktx2Transcoder/zstddec.wasm?url';

DracoCompression.Configuration.decoder.wasmBinaryUrl = dracoWasm;
DracoCompression.Configuration.decoder.wasmUrl = dracoWrapper;
DracoCompression.Configuration.decoder.fallbackUrl = dracoFallback;

KhronosTextureContainer2.URLConfig.jsDecoderModule = ktx2JsDecoder;
KhronosTextureContainer2.URLConfig.jsMSCTranscoder = ktx2JsMSCTranscoder;
KhronosTextureContainer2.URLConfig.wasmMSCTranscoder = ktx2MSCTranscoder;
KhronosTextureContainer2.URLConfig.wasmUASTCToASTC = ktx2UASTCToASTC;
KhronosTextureContainer2.URLConfig.wasmUASTCToBC7 = ktx2UASTCToBC7;
// KhronosTextureContainer2.URLConfig.wasmUASTCToR8_UNORM = ktx2UASTCToR8_UNORM;
// KhronosTextureContainer2.URLConfig.wasmUASTCToRG8_UNORM = ktx2UASTCToBG8_UNORM;
KhronosTextureContainer2.URLConfig.wasmUASTCToRGBA_SRGB = ktx2UASTCToRGBA_SRGB;
KhronosTextureContainer2.URLConfig.wasmUASTCToRGBA_UNORM = ktx2UASTCToRGBA_UNORM;
KhronosTextureContainer2.URLConfig.wasmZSTDDecoder = ktx2ZSTDDecoder;
